import { translateFn } from './translator.helper';

export function getTimezone() {
  const user = globalThis.Application.Main.getUser();
  if (!user || !user.profile || !user.profile.timezone) {
    return 'UTC';
  }
  return user.profile.timezone;
}

/**
 * For a given startDate and a number of days determine the number of days left
 */
export function calculateRemainingDays(startDate: Date, maxAvailableDays: number): number {
  const statusStartDate = new Date(startDate).getTime();
  const now = new Date().getTime();
  const diffTime = Math.abs(now - statusStartDate);
  const diffDays = maxAvailableDays - Math.floor(diffTime / (1000 * 60 * 60 * 24));
  return Math.max(diffDays, 1);
}

/**
 * Get the pluralised version by day (day/days) based on a value
 */
export function getPluralisedTextByDay(value: number): string {
  return value === 1 ? translateFn('day') : translateFn('days');
}

/**
 * Appends value at the provided position
 */
export function augmentTextWithValue(value: any, pos: number, ...texts: string[]): string {
  let tooltipText = '';

  if (pos > texts.length || pos < 0) {
    return tooltipText;
  }

  if (pos === 0) {
    tooltipText += value + ' ';
  }

  for (const [i, text] of texts.entries()) {
    if (i !== 0 && i === pos) {
      tooltipText += ' ' + value + ' ';
    }
    tooltipText += text;
  }

  if (pos === texts.length) {
    tooltipText += ' ' + value;
  }

  return tooltipText;
}
